export default "__VITE_ASSET__BMQ$FbL6__"